(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
    class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.classList.add('hide');
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.classList.toggle('hide');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);
  document.addEventListener('DOMContentLoaded', function() {
    var menu = document.querySelector('.brands-megamenu[data-brands-menu]');
    if (!menu) return;

    var searchInput = menu.querySelector('.brands-search-input');
    var letterButtons = menu.querySelectorAll('.brands-letter');
    var items = menu.querySelectorAll('[data-brand-item]');
    var groupTitles = menu.querySelectorAll('.brands-group-title');
    var activeLetter = 'all';

    function applyFilter() {
      var query = '';
      if (searchInput) {
        query = searchInput.value.toLowerCase().trim();
      }

      var i;
      var visibleByLetter = {};

      for (i = 0; i < items.length; i++) {
        var item = items[i];
        var name = item.getAttribute('data-name');
        var letter = item.getAttribute('data-letter');

        var matchesLetter = (activeLetter === 'all' || letter === activeLetter);
        var matchesQuery = (!query || (name && name.indexOf(query) !== -1));

        if (matchesLetter && matchesQuery) {
          item.style.display = '';
          visibleByLetter[letter] = true;
        } else {
          item.style.display = 'none';
        }
      }

      // arătăm / ascundem literele de grup în funcție de rezultate
      for (i = 0; i < groupTitles.length; i++) {
        var title = groupTitles[i];
        var group = title.getAttribute('data-letter-group');

        if (activeLetter !== 'all' && group !== activeLetter) {
          title.style.display = 'none';
        } else if (visibleByLetter[group]) {
          title.style.display = '';
        } else {
          title.style.display = 'none';
        }
      }
    }

    if (searchInput) {
      searchInput.addEventListener('input', function() {
        applyFilter();
      });
    }

    for (var j = 0; j < letterButtons.length; j++) {
      letterButtons[j].addEventListener('click', function(e) {
        e.preventDefault();
        activeLetter = this.getAttribute('data-letter-filter');

        for (var k = 0; k < letterButtons.length; k++) {
          letterButtons[k].classList.remove('brands-letter--active');
        }
        this.classList.add('brands-letter--active');

        applyFilter();
      });
    }

    // filtru inițial
    applyFilter();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      })
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }
  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
